import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Services
import { CancelService } from './services/cancel.service';
import { PollCompletionService } from './services/poll-completion.service';
import { PollingService } from './services/polling.service';

// Interceptors
import { PollingHeaderInterceptor } from './interceptors/polling-header.interceptor';

/**
 * CoreModule - Centralized polling infrastructure
 * 
 * This module provides:
 * - Polling services (PollingService, PollCompletionService, CancelService)
 * - PollingHeaderInterceptor for automatic header detection
 * 
 * IMPORTANT: This module should be imported ONLY ONCE in AppModule
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    CancelService,
    PollCompletionService,
    PollingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PollingHeaderInterceptor,
      multi: true
    }
  ],
  exports: []
})
export class CoreModule {
  /**
   * Guard against reimporting CoreModule
   * Ensures singleton services remain singleton
   */
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only.'
      );
    }
  }
}
